module.exports = __webpack_public_path__ + "img/digster.a76786a7.jpg";